/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_EyebrowInputs */

const en_platform_rail_eyebrow = /** @type {(inputs: Platform_Rail_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you get`)
};

const pl_platform_rail_eyebrow = /** @type {(inputs: Platform_Rail_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co dostajesz`)
};

/**
* | output |
* | --- |
* | "What you get" |
*
* @param {Platform_Rail_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_eyebrow = /** @type {((inputs?: Platform_Rail_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_eyebrow(inputs)
	return en_platform_rail_eyebrow(inputs)
});